<div class="page-container">
  <app-card>
    <div class="scrollable-content">
      <app-card-content class="flex-align-center">
        <div class="flex-column flex-align-center">
          <img [src]="'logos/checkpoint-logo-horizontal.png' | envPrefix:'brand'" alt="CheckPoint" class="home-logo"
            data-testid="home-logo" />
          <h2 class="m-auto-center" data-testid="home-heading">{{ 'home.welcome' | translate }}</h2>
          <div>{{ 'home.description' | translate }}</div>
        </div>
        @if (showOnboardingLink()) {
        <p class="onboarding-link-wrapper">
          <a routerLink="/onboarding" class="onboarding-link" data-testid="return-to-onboarding-link">
            {{ 'home.returnToGuide' | translate }}
          </a>
        </p>
        }
      </app-card-content>
      <app-card-actions>
        <app-button data-testid="scan-button" variant="filled" routerLink="/scan">
          <app-icon name="scan" />
          {{ 'home.scanButton' | translate }}
        </app-button>
        <app-button data-testid="browse-checkpoints-button" variant="outlined" routerLink="/checkpoints">
          <app-icon name="checkpoint" />
          {{ 'home.browseCheckpointsButton' | translate }}
        </app-button>
        <app-button data-testid="browse-forms-button" variant="outlined" routerLink="/forms">
          <app-icon name="form" />
          {{ 'home.browseFormsButton' | translate }}
        </app-button>
      </app-card-actions>
    </div>
  </app-card>
</div>